import React from 'react';
import { getUITranslation } from './utils';
import { RECIPE_TYPES } from './translations';

const Nutrition = ({ nutrition, recipeType, lang }) => {
    if (!nutrition || Object.keys(nutrition).length === 0) {
        return <div className="nutrition-empty">{getUITranslation('noNutritionInfo', lang)}</div>;
    }
    
    // Determine protein icon based on recipe type
    const proteinIcon = recipeType === RECIPE_TYPES.VEGETARIAN ? '🌱' : '🥩';
    
    return (
        <div className="nutrition-info">
            <div className="nutrition-row">
                <div className="nutrition-card">
                    <span className="nutrition-icon">{proteinIcon}</span>
                    <span className="nutrition-value"><b>{nutrition.protein ?? '--'}g</b></span>
                    <span className="nutrition-label">{getUITranslation('protein', lang)}</span>
                </div>
                <div className="nutrition-card">
                    <span className="nutrition-icon">🌾</span>
                    <span className="nutrition-value"><b>{nutrition.carbs ?? '--'}g</b></span>
                    <span className="nutrition-label">{getUITranslation('carbs', lang)}</span>
                </div>
                <div className="nutrition-card">
                    <span className="nutrition-icon">🧈</span>
                    <span className="nutrition-value"><b>{nutrition.fat ?? '--'}g</b></span>
                    <span className="nutrition-label">{getUITranslation('fat', lang)}</span>
                </div>
            </div>
            <div className="nutrition-row">
                <div className="nutrition-card">
                    <span className="nutrition-icon">🔥</span>
                    <span className="nutrition-value"><b>{nutrition.kcal ?? '--'}</b></span>
                    <span className="nutrition-label">{getUITranslation('kcal', lang)}</span>
                </div>
                <div className="nutrition-card">
                    <span className="nutrition-icon">🍽️</span>
                    <span className="nutrition-value"><b>{nutrition.servings ?? '--'}</b></span>
                    <span className="nutrition-label">{getUITranslation('servings', lang)}</span>
                </div>
            </div>
        </div>
    );
};

export default Nutrition; 